import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
export function HuntingGearBlinds() {
  useDocumentMeta('Hunting Gear & Blinds in Lake Benton, Minnesota | Kjergaard Sports', 'Prepare for hunting season with hunting blinds, field gear, and outdoor supplies at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Hunting blinds', 'Field gear', 'Outdoor gear', 'Hunting season preparation'];
  return <div data-id="element-432">
      <PageHero title="Hunting Gear & Blinds" image="https://cdn.magicpatterns.com/uploads/916kAQgnnbRYFKKSKvhkwD/hunting-apparel-gear.jpg" alt="Large in-store selection at Kjergaard Sports in Lake Benton, Minnesota" data-id="element-433" />

      <section className="py-20 bg-brand-offwhite" data-id="element-434">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-435">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-436">
            <div className="order-2 lg:order-1" data-id="element-437">
              <img src="https://cdn.magicpatterns.com/uploads/916kAQgnnbRYFKKSKvhkwD/hunting-apparel-gear.jpg" alt="Hunting gear selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-438" />
            </div>

            <div className="order-1 lg:order-2" data-id="element-439">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-440">
                Prepare for the Field
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-441">
                Hunters are the core of our business. Before you head into the
                woods, the marsh, or the fields, make Kjergaard Sports your
                first stop. We carry the durable, practical gear you need to
                stay concealed, comfortable, and ready when the moment counts.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-442">
                <h3 className="font-serif text-xl mb-4" data-id="element-443">We Stock:</h3>
                <ul className="space-y-3" data-id="element-444">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-445">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-446" />
                      <span className="text-brand-charcoal/90" data-id="element-447">{item}</span>
                    </li>)}
                </ul>
              </div>

              <Link to="/contact" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-448">
                <MapPin className="w-5 h-5 mr-2" data-id="element-449" />
                Plan Your Visit Before Hunting Season
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}